import usePortfolio from "../hooks/PortfolioProvider";
import PerformanceRow from "../models/PerformanceRow";
import Utils from "../portlibs/PortUtils";
import Holding from "../models/Holding";
import SectorTable from "../components/sector/SectorTable";
import { ESectors } from "../shared/Consts";
import PortUtils from "../portlibs/PortUtils";
import { usePath } from "../libs/path/PathProvider";
import Toolbar from "../components/widgets/Toolbar";
import DateRangeFilter from "../components/widgets/DateRangeFilter";

type TSectors = Record<string,PerformanceRow>

const COLS = ["sector","holdingValue","gain","holdingPercent","holdingPortion"]

function addSector(sectors:TSectors, sector:ESectors, holding:Holding, portion:number){
    const sec = Utils.sector(sector)
    if (!(sec in sectors)) sectors[sec] = new PerformanceRow(sector);
    sectors[sec].addHolding(holding, portion)
}
export default function SectionPage(){
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()

    let sectors : TSectors = {}
    let totalValue = 0;
    const holdings = portfolio.filter(currency, filter, account, false)
    for(let holding of holdings){
        const price = holding.price;
        if (!price) continue
        else totalValue += holding.holdingValue;
        if (price.sectors){
            for(let sector of price.sectors) addSector(sectors, sector[0], holding, sector[1])
        }
        else if (price.sector) addSector(sectors, price.sector, holding, 1)
    }
    const rows : PerformanceRow[] = []
    for(let sector in sectors){
        const row = sectors[sector]
        row.holdingPercent = row.holdingCost ? row.gain/row.holdingCost*100 : 0;
        row.holdingPortion = row.holdingValue/totalValue*100;
        rows.push(row)
    }
    return <>
        <Toolbar><DateRangeFilter/></Toolbar>
        <div id="sectors" className="flex1 scroller"><SectorTable rows={rows} cols={COLS}/></div>
    </>
}